import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import { chPatientByIdQuery$data } from "@/modules/patients/services/ch/__generated__/chPatientByIdQuery.graphql"
import { dePatientByIdQuery$data } from "@/modules/patients/services/de/__generated__/dePatientByIdQuery.graphql"
import { usePatientByIdQuery } from "@/modules/patients/services/usePatientByIdQuery"

type DePatientPrevention = NonNullable<dePatientByIdQuery$data["patientById"]>["preventionPrograms"]
type ChPatientPrevention = NonNullable<chPatientByIdQuery$data["patientById"]>["preventionPrograms"]

type PreventionProgramNode = NonNullable<NonNullable<ChPatientPrevention>["edges"]>[number]["node"]

export type PatientPrevention = PreventionProgramNode

export interface PreventionProgramWithData {
  id: string
  data: PatientPrevention
}

interface PatientPreventionResult {
  preventionProgramItems: PreventionProgramWithData[]
  preventionPrograms: ChPatientPrevention | DePatientPrevention | undefined
}

function usePatientPrevention(patientId: string, countryCode: Country): PatientPreventionResult {
  // We are fetching from the store but we should pass Fragment top down and not rely on this
  // Currently we can't do this because of the drawer code architecture
  const appointmentId = useAppointmentParam()
  const [patientData] = usePatientByIdQuery(patientId, countryCode, appointmentId)

  if (!patientData.patientById) {
    return { preventionProgramItems: [], preventionPrograms: undefined }
  }

  const preventionProgramItems: PreventionProgramWithData[] =
    patientData.patientById.preventionPrograms?.edges?.map((edge): PreventionProgramWithData => ({
      id: edge.node.id,
      data: edge.node,
    })) ?? []

  return {
    preventionProgramItems,
    preventionPrograms: patientData.patientById.preventionPrograms,
  }
}

export { usePatientPrevention }
